/**
 * Labstep
 */

import { PostFilter } from 'labstep-web/services/postFilter';
import { PostFilterComparison } from 'labstep-web/services/postFilter/constants';

export const PostFilterExperimentWorkflowResourceItem =
  new PostFilter(
    [['guid', PostFilterComparison.eq]],
    'experiments.protocolValues.resourceItem',
  );

export const getPostFilterExperimentWorkflowResourceItem = (
  path?: string,
) =>
  new PostFilter(
    [['guid', PostFilterComparison.eq]],
    path ? path : 'experiments.protocolValues.resourceItem',
  );
